'use client';

import { Alert, Link } from '@coolblue-development/freddy';
import selectRemoveAllFiltersTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilterResults/selectRemoveAllFiltersTrigger';
import showNoResultsBannerTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilterResults/showNoResultsBannerTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import { useClientUrl } from '@utils/url-generators/useClientUrl';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useFiltersContext } from '../Context/useFiltersContext';

export const NoFilterResult = () => {
  const { t } = useTranslation('filterPage.noResult');
  const { clearAllSearchParams } = useFiltersContext();
  const { trackEvent } = useAnalytics();
  const router = useRouter();
  const filterPageUrl = useClientUrl('filterPage')!;

  useEffect(() => {
    trackEvent(showNoResultsBannerTrigger());
  }, [trackEvent]);

  const handleClearSearchResults = () => {
    trackEvent(selectRemoveAllFiltersTrigger());
    clearAllSearchParams();
    // needs for the category page
    router.push(filterPageUrl);
  };

  return (
    <Alert
      hideIcon
      description={t('description')}
      action={
        <Link component='button' startIcon={<ArrowRight />} onClick={handleClearSearchResults}>
          {t('link')}
        </Link>
      }
    />
  );
};
